import React from 'react';
import StakeholderInfo from '../../../../../components/Forms/stakeholder/info';

function PMEStakeholderInfo() {
	return <StakeholderInfo module="pme" view="stakeholders" drawerTitle="Edit stakeholder"/>;
}
export default PMEStakeholderInfo;
